export default class UtilityProvince{

    constructor(jsonResponse){

        this.displayName = jsonResponse["display-name"];
        this.value = jsonResponse["value"];

        this.id = this.value;
        this.name = this.displayName;

    }


    static fromIso(providedValue) {
        let value = providedValue;

        switch (value) {
            case "EC":
                return "EASTERN_CAPE";
            case "FS":
                return "FREE_STATE";
            case "GP":
                return "GAUTENG";
            case "KZN":
                return "KWAZULU_NATAL";
            case "LP":
                return "LIMPOPO";
            case "MP":
                return "MPUMALANGA";
            case "NW":
                return "NORTH_WEST";
            case "NC":
                return "NORTHERN_CAPE";
            case "WC":
                return "WESTERN_CAPE";
            default:
                return value;
        }
    }

}
